var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { SAVE_AND_SUBMIT_ACTION, REST_API_ACTION, LOOKUP_ACTION, } from "../constants/common";
import { handleDeleteRequestType, handleGetRequestType, handlePostRequestType, handlePutRequestType, onSaveAndSubmit, } from "../services/CustomActionService";
import formatRestApiEndpoint from "./FormatRestApiEndpoint";
import { showPicker } from "../components/common/ModalPicker";
import { showToastMessage } from "../components/common/ToastMessage";
var formatPayloadForPostOrPutRequest = function (obj, variableObj) {
    Object.keys(obj).forEach(function (key) {
        if (typeof obj[key] === "string") {
            if (obj[key].startsWith("${") && obj[key].endsWith("}")) {
                var val = obj[key].substring(obj[key].lastIndexOf("${") + 2, obj[key].lastIndexOf("}"));
                if (val === "submissionData")
                    obj[key] = variableObj;
                else if (variableObj[val] !== undefined)
                    obj[key] = variableObj[val];
                // else obj[key] = "";
            }
        }
        else if (typeof obj[key] === "object") {
            if (!Array.isArray(obj[key])) {
                formatPayloadForPostOrPutRequest(obj[key], variableObj);
            }
        }
    });
    return obj;
};
var generatePayloadForPostOrPutRequest = function (event, isSubmissionDataRequestBody, requestBody) {
    var payload = {};
    var _a = event.data, submit = _a.submit, data = __rest(_a, ["submit"]);
    if (isSubmissionDataRequestBody) {
        payload = data;
    }
    else {
        var reqBody = typeof requestBody === "object" ? requestBody : {};
        payload = formatPayloadForPostOrPutRequest(__assign({}, reqBody), data);
    }
    return payload;
};
var handleCustomEvent = function (event, form, onCustomEvent, updateSubmission) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, id, formKey, lookupEndpoint, lookupType, tableHeaders, tableLabel, queryParameters, _b, submit, submissionData, _c, lookupInfo, reqBody, _d, endpoint, _e, requestType, requestBody, isSubmissionDataRequestBody, isDisplayResponseMessage_1, displayMessageType_1, customMessage_1, mapResponseKey_1, mapResponseKeyWithFieldId_1, handleToastMessage, mapResponseWithFields, _f, getResponse, success, _g, message, data, postResponse, success, _h, message, data, putResponse, success, _j, message, deleteResponse, success, _k, message;
    return __generator(this, function (_l) {
        switch (_l.label) {
            case 0:
                _a = event.component, id = _a.id, formKey = _a.formKey, lookupEndpoint = _a.endpoint, lookupType = _a.lookupType, tableHeaders = _a.tableHeaders, tableLabel = _a.tableLabel, queryParameters = _a.queryParameters, _b = event.data, submit = _b.submit, submissionData = __rest(_b, ["submit"]);
                _c = event.type;
                switch (_c) {
                    case LOOKUP_ACTION: return [3 /*break*/, 1];
                    case SAVE_AND_SUBMIT_ACTION: return [3 /*break*/, 2];
                    case REST_API_ACTION: return [3 /*break*/, 4];
                }
                return [3 /*break*/, 14];
            case 1:
                lookupInfo = {
                    endpoint: lookupEndpoint,
                    formKey: formKey,
                    lookupType: lookupType,
                    tableHeaders: tableHeaders,
                    tableLabel: tableLabel,
                    queryParameters: queryParameters,
                    lookupButtonId: id,
                };
                showPicker(lookupInfo);
                return [3 /*break*/, 15];
            case 2:
                reqBody = {
                    formId: form.id,
                    formVersion: form.version,
                    formData: submissionData,
                };
                _d = onCustomEvent;
                return [4 /*yield*/, onSaveAndSubmit(reqBody)];
            case 3:
                _d.apply(void 0, [_l.sent()]);
                return [3 /*break*/, 15];
            case 4:
                endpoint = formatRestApiEndpoint(lookupEndpoint, queryParameters, submissionData);
                _e = event === null || event === void 0 ? void 0 : event.component, requestType = _e.requestType, requestBody = _e.requestBody, isSubmissionDataRequestBody = _e.isSubmissionDataRequestBody, isDisplayResponseMessage_1 = _e.isDisplayResponseMessage, displayMessageType_1 = _e.displayMessageType, customMessage_1 = _e.customMessage, mapResponseKey_1 = _e.mapResponseKey, mapResponseKeyWithFieldId_1 = _e.mapResponseKeyWithFieldId;
                handleToastMessage = function (success, message) {
                    if (success && isDisplayResponseMessage_1) {
                        if (displayMessageType_1 === "apiResponseMessage") {
                            showToastMessage({
                                isOpen: true,
                                message: message,
                            });
                        }
                        else {
                            showToastMessage({
                                isOpen: true,
                                message: customMessage_1,
                            });
                        }
                    }
                };
                mapResponseWithFields = function (data) {
                    if (mapResponseKey_1) {
                        var mappedField_1 = {};
                        mapResponseKeyWithFieldId_1 === null || mapResponseKeyWithFieldId_1 === void 0 ? void 0 : mapResponseKeyWithFieldId_1.forEach(function (_a) {
                            var responseKey = _a.responseKey, fieldId = _a.fieldId;
                            if (data[responseKey]) {
                                mappedField_1[fieldId] = data[responseKey];
                            }
                        });
                        console.log(mappedField_1);
                        updateSubmission(mappedField_1);
                    }
                };
                _f = requestType;
                switch (_f) {
                    case "get": return [3 /*break*/, 5];
                    case "post": return [3 /*break*/, 7];
                    case "put": return [3 /*break*/, 9];
                    case "delete": return [3 /*break*/, 11];
                }
                return [3 /*break*/, 13];
            case 5: return [4 /*yield*/, handleGetRequestType(endpoint)];
            case 6:
                getResponse = _l.sent();
                success = getResponse.success, _g = getResponse.message, message = _g === void 0 ? "" : _g, data = getResponse.data;
                handleToastMessage(success, message);
                mapResponseWithFields(data);
                onCustomEvent(getResponse);
                return [3 /*break*/, 13];
            case 7: return [4 /*yield*/, handlePostRequestType(endpoint, generatePayloadForPostOrPutRequest(event, isSubmissionDataRequestBody, requestBody))];
            case 8:
                postResponse = _l.sent();
                success = postResponse.success, _h = postResponse.message, message = _h === void 0 ? "" : _h, data = postResponse.data;
                handleToastMessage(success, message);
                mapResponseWithFields(data);
                onCustomEvent(postResponse);
                return [3 /*break*/, 13];
            case 9: return [4 /*yield*/, handlePutRequestType(endpoint, generatePayloadForPostOrPutRequest(event, isSubmissionDataRequestBody, requestBody))];
            case 10:
                putResponse = _l.sent();
                success = putResponse.success, _j = putResponse.message, message = _j === void 0 ? "" : _j;
                handleToastMessage(success, message);
                onCustomEvent(putResponse);
                return [3 /*break*/, 13];
            case 11: return [4 /*yield*/, handleDeleteRequestType(endpoint)];
            case 12:
                deleteResponse = _l.sent();
                success = deleteResponse.success, _k = deleteResponse.message, message = _k === void 0 ? "" : _k;
                handleToastMessage(success, message);
                onCustomEvent(deleteResponse);
                return [3 /*break*/, 13];
            case 13: return [3 /*break*/, 15];
            case 14:
                if (onCustomEvent)
                    onCustomEvent(event);
                return [3 /*break*/, 15];
            case 15: return [2 /*return*/];
        }
    });
}); };
export default handleCustomEvent;
//# sourceMappingURL=HandleCustomEvent.js.map